export const MIN_CARD_HEIGHT = 240
